module.exports = __webpack_public_path__ + "fonts/almoni-light-aaa.652ad42.woff2";